import type { IconData } from '@stacksjs/iconify-core'

export const disableHeartRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.914 1.086a2 2 0 1 0-2.828 2.828l43 43a2 2 0 1 0 2.828-2.828l-8.16-8.16c4.91-4.488 8.746-10.143 8.746-17.106c0-7.29-5.949-14.31-14.38-14.41h-.024a14.7 14.7 0 0 0-7.771 2.218c-.509.315-.951.63-1.325.922a15 15 0 0 0-1.325-.922a14.7 14.7 0 0 0-7.771-2.219c-2.297 0-4.408.51-6.264 1.403zm2.52 11.7a2 2 0 0 0-3.275-2.298C1.455 12.917.5 15.845.5 18.818c0 5.837 2.703 10.763 6.45 14.829c3.733 4.052 8.615 7.379 13.276 10.078a7.53 7.53 0 0 0 7.548 0a81 81 0 0 0 5.28-3.316a2 2 0 1 0-2.267-3.297a77 77 0 0 1-5.018 3.152a3.53 3.53 0 0 1-3.538 0c-4.523-2.62-9.005-5.708-12.34-9.328C6.569 27.33 4.5 23.327 4.5 18.82c0-2.126.687-4.256 1.934-6.034\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default disableHeartRemix
